import React from "react";
import { RaisedButton } from "material-ui";
import BaseOverlay from "../overlays/base.jsx";

class LeaveModalWarning extends React.Component {
  constructor(props) {
    super(props);

    this.stay = this.stay.bind(this);
    this.leave = this.leave.bind(this);
  }

  leave() {
    this.props.leave();
  }

  stay() {
    this.props.stay();
  }

  render() {
    return (
      <div style={{ textAlign: "center", fontSize: "11pt", padding: 15, paddingBottom: 35 }}>
        <h3>
          Are you sure you want to leave checkout?
        </h3>        
        <div>
          <p>
            If you leave this page, you'll lose your hold on the currently selected seats.
          </p>
          <div style={{ marginTop: 10 }}>
            <RaisedButton
              label="Leave"          
              onClick={this.leave}
            />
            <RaisedButton
              label="Stay in checkout"
              primary={true}
              style={{ marginLeft: 15 }}
              onClick={this.stay}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default LeaveModalWarning;



// WEBPACK FOOTER //
// ./src/app/components/partials/leave-modal-warning.jsx